import Ajv from 'ajv';
import { ApiFieldDataResponseSchema } from './ApiFieldDataResponse.schema';
import { ApiFormChoicesResponseSchema } from './ApiFormChoicesResponse.schema';
var ajv = new Ajv({
  allErrors: true,
  coerceTypes: false,
  format: 'fast',
  nullable: true,
  schemaId: 'auto',
  unicode: true,
  uniqueItems: true,
  useDefaults: true
}).addMetaSchema(require('ajv/lib/refs/json-schema-draft-04.json'));
var schemas = {
  ApiFieldDataResponseSchema: ApiFieldDataResponseSchema,
  ApiFormChoicesResponseSchema: ApiFormChoicesResponseSchema
};
export var validate = function validate(schema, data) {
  var _ajv$errors;
  var schemaInUse = schemas[schema];
  var isValid = !!ajv.validate(schemaInUse, data);
  return {
    isValid: isValid,
    errors: (_ajv$errors = ajv.errors) !== null && _ajv$errors !== void 0 ? _ajv$errors : undefined
  };
};